import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import API_BASE from "../config/api";

export default function HeroSection() {
  const navigate = useNavigate();

  const [provinces, setProvinces] = useState([]);
  const [categories, setCategories] = useState([]);
  const [searchText, setSearchText] = useState("");

  const [selectedProvince, setSelectedProvince] = useState("Province");
  const [selectedCategory, setSelectedCategory] = useState("Categories");

  useEffect(() => {
    fetch(`${API_BASE}/api/getProvinces.php`)
      .then(res => res.json())
      .then(data => setProvinces(data.provinces || []));

    fetch(`${API_BASE}/api/getCategories.php`)
      .then(res => res.json())
      .then(data => setCategories(data.categories || []));
  }, []);

  const goToSearch = () => {
    const province = selectedProvince === "Province" ? "" : selectedProvince;
    const category = selectedCategory === "Categories" ? "" : selectedCategory;
    const search = searchText.trim();

    navigate(`/search?search=${search}&location=${province}&category=${category}`);
  };


  return (
    <>
      {/* Internal CSS */}
      <style>{`
        :root {
          --brand-primary: #1E49FF;
          --headline: #0B1220;
          --muted: #6B7280;
          --pill-radius: 8px;
          --bar-height: 50px;
        }

        .hero-wrap {
          padding: 40px 0 24px;
          text-align: center;
        }

        .hero-title {
          font-size: 48px;
          font-weight: 700;
          color: var(--headline);
        }

        @media (max-width: 991px) {
          .hero-title { font-size: 40px; }
        }

        @media (max-width: 575px) {
          .hero-title { font-size: 32px; }
        }
      `}</style>
      <style>{`
        /* Animated colorful border for search card */
        /* Animated colorful border for search card */
      .search-shell {
        position: relative;
        border: 1px solid #959ca3ff;  
        border-radius: 10px !important;
        padding: 1px; /* border thickness */
        
        background-size: 400% 400%;
        
      }

      /* Inner white card (actual content) */
      .search-shell::before {
        content: "";
        position: absolute;
        inset: 4px; /* SAME AS padding */
        background: #ffffff;
        border-radius: 10px; /* slightly smaller than parent */
        z-index: 0;
      }

      /* Bring content above white layer */
      .search-shell > * {
        position: relative;
        z-index: 2;
      }

    .dropdown-menu {
    position: absolute;
    z-index: 5000 !important;
}



    
      `}</style>



      <section className="hero-wrap container">


        {/* Search Bar */}
        <div className="search-shell mt-1 p-3 shadow-sm bg-white rounded" style={{ maxWidth: "1000px", margin: "0 auto" }}>

          {/* FIXED FULL RESPONSIVE LAYOUT */}
          <div className="d-flex flex-column flex-lg-row align-items-stretch gap-2 w-100">

            {/* SEARCH INPUT */}
            <div className="input-group flex-grow-1">
              <span className="input-group-text bg-white border-0">
                <i className="bi bi-search fs-5 text-secondary"></i>
              </span>

              <input
                type="text"
                placeholder="What are you looking?"
                className="form-control border-0 shadow-none"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
            </div>

            {/* PROVINCE DROPDOWN */}
            <div className="dropdown w-100 w-lg-auto">
              <button className="btn bg-white border rounded w-100 d-flex justify-content-between align-items-center"
                data-bs-toggle="dropdown"
              >
                <span><i className="bi bi-geo-alt fs-5 me-1"></i> {selectedProvince}</span>
                <i className="bi bi-chevron-down"></i>
              </button>

              <ul className="dropdown-menu w-100">
                {provinces.length > 0 ? (
                  provinces.map((item) => (
                    <li key={item.id}>
                      <button className="dropdown-item" onClick={() => setSelectedProvince(item.provinceName)}>
                        {item.provinceName}
                      </button>
                    </li>
                  ))
                ) : (
                  <li className="dropdown-item text-muted">Loading...</li>
                )}
              </ul>
            </div>

            {/* CATEGORY DROPDOWN */}
            <div className="dropdown w-100 w-lg-auto">
              <button className="btn bg-white border rounded w-100 d-flex justify-content-between align-items-center w-100 w-lg-25 text-truncate"
                data-bs-toggle="dropdown"
              >
                <span><i className="bi bi-grid-3x3-gap fs-5 me-1"></i> {selectedCategory}</span>
                <i className="bi bi-chevron-down"></i>
              </button>

              <ul className="dropdown-menu w-100">
                {categories.length > 0 ? (
                  categories.map((item) => (
                    <li key={item.id}>
                      <button className="dropdown-item" onClick={() => setSelectedCategory(item.catagories)}>
                        {item.catagories}
                      </button>
                    </li>
                  ))
                ) : (
                  <li className="dropdown-item text-muted">Loading...</li>
                )}
              </ul>
            </div>

            {/* SEARCH BUTTON */}
            <button className="btn btn-primary w-50 w-lg-auto" onClick={goToSearch}>
              Search
            </button>

          </div>
        </div>
      </section>
    </>
  );
}
